<template>
	<div class="w-full py-6">
        <div class="flex">
            <div class="w-1/4">
                <div class="relative mb-2">
                    <div class="w-10 h-10 mx-auto rounded-full text-lg flex items-center"
                    :class="{'bg-primary text-white': step == 0, 'bg-white text-gray-300': step != 0}">
                        <span class="text-center w-full">1</span>
                    </div>
                </div>
            </div>
            <div class="w-1/4">
                <div class="relative mb-2">
                    <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
                        <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
                            <div class="w-0 bg-primary py-1 rounded" style="width: 0%;"></div>
                        </div>
                    </div>
                    <div class="w-10 h-10 mx-auto rounded-full text-lg flex items-center"
                    :class="{'bg-primary text-white': step == 1, 'bg-white text-gray-300': step != 1}">
                        <span class="text-center w-full">2</span>
                    </div>
                </div>
            </div>
            <div class="w-1/4">
                <div class="relative mb-2">
                    <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
                        <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
                            <div class="w-0 bg-primary py-1 rounded" style="width: 0%;"></div>
                        </div>
                    </div>
                    <div class="w-10 h-10 mx-auto rounded-full text-lg flex items-center"
                    :class="{'bg-primary text-white': step == 2, 'bg-white text-gray-300': step != 2}">
                        <span class="text-center w-full">3</span>
                    </div>
                </div>
            </div>  
            <div class="w-1/4">
                <div class="relative mb-2">
                    <div class="absolute flex align-center items-center align-middle content-center" style="width: calc(100% - 2.5rem - 1rem); top: 50%; transform: translate(-50%, -50%)">
                        <div class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1">
                            <div class="w-0 bg-primary py-1 rounded" style="width: 0%;"></div>
                        </div>
                    </div>
                    <div class="w-10 h-10 mx-auto rounded-full text-lg flex items-center"
                    :class="{'bg-primary text-white': step == 3, 'bg-white text-gray-300': step != 3}">
                        <span class="text-center w-full">4</span>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
export default {
    props: {
        step: {
            type: Number,
            default: 0
        }
    }
}
</script>